import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import { Layout } from './Layout';
import QuotePopup from './Website/components/OtherComps/QuotePopup/QuotePopup';



function App() {
  return (
    <Router>
      <div className="App">
        <Layout />
        <QuotePopup />
      </div>
    </Router>
  );
}

export default App;
